<template>
    <div>
    <v-dialog @keydown.esc="closeDistPointsModal"  max-width="450" persistent v-model="$store.getters.copyDistPointsModal">
        <v-card >
            <v-card-title class="white--text primary text-center justify-center">
                <h4>Επιβεβαίωση</h4>
                <v-spacer></v-spacer>
                <v-icon @click="closeDistPointsModal" color="white">close</v-icon>
            </v-card-title>
            <br/>
            <v-form class="mx-2">
                <v-card-text>
                    Ο μηχανισμός μεταφοράς θα διαγράψει ΟΛΑ τα Σημεία Διανομής από τις επιλογές (μάθημα-βιβλίο) του "Υπό Διαμόρφωση" έτους {{$store.getters.editedYear}} και θα τις αντικαταστήσει με τα Σημεία Διανομής από τις αντίστοιχες επιλογές του προηγούμενου έτους .
                    Η αντιστοίχιση θα γίνει σε επίπεδο Τμήματος όπου για κάθε συνδυασμό {Τμήμα - Μαθήμα - Βιβλίο} στο Υπό Διαμόρφωση έτος θα επιλεγούν τα Σημεία Διανομής που συμμετείχαν στο συνδυασμό {Τμήμα - Βιβλίο} στο προηγούμενο έτος.
                    <b>Θέλετε να συνεχίσετε;</b>
                </v-card-text>
                <v-card-actions>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-btn id="okButton" class="btn" color="primary" primary @click="startCopyingDistPoints">Οκ</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="btn" color="primary"  primary @click="closeDistPointsModal">Ακύρωση</v-btn>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
    import utils from "../../utilities";
    import request from "../../requests";

    export default {
        name: "CopyDistPointsModal",
        methods: {
            closeDistPointsModal() {
                this.$store.commit('setCopyDistPointsModal', false);
            },
            startCopyingDistPoints() {
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    console.log(token);
                    this.$store.commit('setLoadingModal', true);
                    this.$store.commit('setCopyDistPointsModal', false);
                    request.copyDistPoints(token, this.copyDistPointsCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },
            copyDistPointsCallBack(response) {

                this.$store.commit('setLoadingModal', false);

                var errorPopupProps = {
                    title: 'Μεταφορά Σημείων Διανομής',
                    text: 'Επιτυχής Μεταφορά Σημείων Διανομής. Παρακαλούμε επιλέξτε το "Χωρίς Σημεία Διανομής" για να δείτε σε ποιές επιλογές δεν έχει οριστεί.',
                    color: 'primary',
                    class: 'white--text primary text-center justify-center',
                    icon:'success',
                    successStyle:true,
                    fontStyleBig:false,
                };

                this.$store.commit('setErrorPopupProps', errorPopupProps);
                this.$store.commit('setErrorPopup', true);
            },
        },
    }
</script>

<style scoped>
    .btn {
        text-transform: none;
        margin-bottom: 25px;

    }
    #okButton {
        width: 100px;
    }
</style>